<template>
  <div
    id="form-block"
    class="relative flex h-screen w-full flex-col sm:min-h-[768px] sm:flex-row">
    <div
      id="white-login-box"
      class="flex flex-none flex-col items-center px-[25px] pb-10 pt-[50px] shadow-lg sm:min-h-screen sm:w-[550px] sm:p-[75px]"
      :class="[position, `h-[${minHeight}]`]">
      <div>
        <img
          id="wayfinder-logo-black"
          src="../assets/icon-black.png"
          alt=""
          class="mb-[50px]" />
        <slot name="content"></slot>
      </div>
    </div>
    <div class="relative grow">
      <div
        id="topo-block"
        class="absolute z-20 size-full">
        <div
          id="topo"
          class="size-full"></div>
      </div>
      <div
        id="photo-background"
        class="relative size-full">
        <div :class="[`photo-` + random, `w-full`, `h-full`]"></div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import {
  defineComponent
} from "vue";
import Helpers from "@/mixins/Helpers";

export default defineComponent({
  name: "UnauthedLayout",
  mixins: [
    Helpers
  ],
  props: {
    random: {
      type: Number,
      default: 1
    },
    height: {
      type: String,
      default: null,
      required: false
    },
    position: {
      type: String,
      default: "sm:justify-center",
      required: false
    }
  },
  data() {
    return {
      form: "login",
      email: "",
      password: "",
      attempts: 0
    };
  },
  computed: {
    minHeight() {
      return this.height || "600px";
    }
  },
  mounted() {
  }
});
</script>

<style scoped lang="scss">
#wayfinder-logo-black {
  height: 48px;
  width: 60px;
}

#centering-box {
  height: 100%;
}

#center-area {
  position: relative;
  max-width: 610px;
  min-width: 610px;
  width: 610px;
  z-index: 3;
  a, a:visited {
    @apply text-dark-green;
  }
}

#photo-background {
  div {
    background-size: cover;
    &.photo-1 {
      background-image: url('../assets/background-orange-hills.jpg');
    }
    &.photo-2 {
      background-image: url('../assets/background-not-found.jpg');
    }
    &.photo-3 {
      background-image: url('../assets/background-blue-ocean.jpg');
    }
    &.photo-4 {
      background-image: url('../assets/background-violet-mountains.jpg');
    }
    &.photo-5 {
      background-image: url('../assets/background-green-falls.jpg');
    }
    &.photo-6 {
      background-image: url('../assets/background-gray-hills.jpg');
    }
  }
}
#topo {
  opacity: .7;
  background: transparent url('../assets/topo-texture-inf.png') repeat;
}
</style>
